import { Injectable } from '@angular/core';

import { LocalStorage } from '../storage/local.storage';
import { UserState } from './user-state';

@Injectable({
  providedIn: 'root',
})
export class UserService implements UserState {
  public constructor(private storage: LocalStorage) {}

  public getAuthEmail(): string | null {
    return this.storage.get('email');
  }

  public setAuthEmail(authToken: string): void {
    this.storage.set('email', authToken);
  }

  public clearAuthEmail(): void {
    this.storage.delete('email');
  }

  public getAuthToken(): string | null {
    return this.storage.get('token');
  }

  public setAuthToken(authToken: string): void {
    this.storage.set('token', authToken);
  }

  public clearAuthToken(): void {
    this.storage.delete('token');
  }

  public hasAuthToken(): boolean {
    return this.storage.has('token');
  }
}
